<rt-box variant="no-padding">
  @if (!hasScroll()) {
    <div layout layout-vertical layout-full-width padding-lr-medium>
      <ng-container *ngTemplateOutlet="userListTpl" />
    </div>
  }
  @if (hasScroll()) {
    <rt-scrollable
      rtScrollTrap
      class="scroll-container"
      layout
      layout-vertical
      layout-full-width
      padding-lr-medium
    >
      <ng-container *ngTemplateOutlet="userListTpl" />
    </rt-scrollable>
  }
  <ng-template #userListTpl>
    @for (role of sharedWithUserRoles(); track role.name; let isLast = $last) {
      <div>
        <div layout layout-horizontal layout-align-items-center padding-tb-small>
          <rt-avatar
            type="icon"
            iconName="person"
            size="small"
            customIconBackgroundColor="colorAvatarGrayLight"
            customIconColor="colorIconDefault"
          />
          <div class="info" layout layout-vertical margin-lr-medium>
            <div class="name">{{ role.name }}</div>
            <div>{{ role.description }}</div>
          </div>
        </div>
        @if (sharedWithUsers().length || !isLast) {
          <rt-divider />
        }
      </div>
    }
    @for (user of sharedWithUsers(); track trackByValue($index, user); let isLast = $last) {
      <div>
        <div layout layout-horizontal layout-align-items-center padding-tb-small>
          <rt-avatar
            [type]="user.hasAvatar ? 'image' : 'initials'"
            [initials]="user.initials"
            [size]="'small'"
            [shape]="'oval'"
            [imageSrc]="user.photoThumbUrl"
            context="admin"
          />
          <div class="info" layout layout-vertical margin-lr-medium>
            <div class="name">{{ user.firstName }} {{ user.lastName }}</div>
            <div>{{ user.roleName }}</div>
          </div>
          @if (withActions()) {
            <div class="actions">
              <rt-icon-button
                size="small"
                iconName="close"
                variant="plain"
                (click)="stopSharingClick.emit(user)"
                data-cy="candidate-sharing-team-members-tab:shared-with-list:user:stop-sharing-button"
              />
            </div>
          }
        </div>
        @if (!isLast) {
          <rt-divider />
        }
      </div>
    }
  </ng-template>
</rt-box>
